import { ContractType } from "./contract";
import { OfferTypeEnum } from "./offerType";
import PaymentOptionDetails from "./paymentOptionDetails";

export enum PaymentOption {
    Check = 1,
    ACH,
    DeferredPay,
    NoDateEstablished,
    CustomPayment1,
    CustomPayment2,
    CustomPayment3,
}

export const AllPaymentOptions: PaymentOption[] = [
    PaymentOption.Check,
    PaymentOption.ACH,
    PaymentOption.DeferredPay,
    PaymentOption.NoDateEstablished,
    PaymentOption.CustomPayment1,
    PaymentOption.CustomPayment2,
    PaymentOption.CustomPayment3,
];

export function listPaymentOptionsForOffer(offerType: Nullish<OfferTypeEnum>): PaymentOption[] {
    switch (offerType) {
        case OfferTypeEnum.Cash:
        case OfferTypeEnum.CashMinPrice:
        case OfferTypeEnum.FixBasisOnHta:
        case OfferTypeEnum.FixFuturesOnBasis:
            return AllPaymentOptions;
        default:
            return AllPaymentOptions.filter(m => m !== PaymentOption.DeferredPay);
    }
}

export function listPaymentOptionsForContract(contractType: ContractType): PaymentOption[] {
    switch (contractType) {
        case ContractType.Cash:
        case ContractType.CashMinPrice:
            return AllPaymentOptions;
        default:
            return AllPaymentOptions.filter(m => m !== PaymentOption.DeferredPay);
    }
}

export function getPaymentOptionName(paymentOption: PaymentOption): string {
    switch (paymentOption) {
        case PaymentOption.Check:
            return "Check";
        case PaymentOption.ACH:
            return "ACH";
        case PaymentOption.DeferredPay:
            return "Deferred Pay";
        case PaymentOption.NoDateEstablished:
            return "No Date Established";
        case PaymentOption.CustomPayment1:
            return "Custom Payment 1";
        case PaymentOption.CustomPayment2:
            return "Custom Payment 2";
        case PaymentOption.CustomPayment3:
            return "Custom Payment 3";
        default:
            return "";
    }
}

export function getPaymentOptionDisplayName(
    paymentOption: Nullish<PaymentOption>,
    paymentOptionsDetails: PaymentOptionDetails[]): string {
    if (paymentOption == null) return "";
    return paymentOptionsDetails.find(pod => pod.paymentOption === paymentOption)?.displayName ?? getPaymentOptionName(paymentOption);
}